var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "list-sessions" },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "mb-0" }, [
            _vm._v(" " + _vm._s(_vm.title) + " ")
          ]),
          _vm.loading
            ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
            : _vm._e(),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "my-data-table",
                attrs: {
                  headers: _vm.computedHeaders.map(function(x) {
                    return Object.assign({}, x, { text: _vm.$t(x.text) })
                  }),
                  items: _vm.sessionsMutated,
                  "item-key": "id",
                  "sort-by": ["updated"],
                  "sort-desc": [true],
                  loading: _vm.loading
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.class",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.classLearner
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.classNames[item.classLearner].class
                                      .displayName
                                  ) +
                                  " "
                              )
                            ]
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.module",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.contentDisplayName(item.module)) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.created",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.created
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatDateTime(item.created)) +
                                  " "
                              )
                            ]
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.updated",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.updated
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatDateTime(item.updated)) +
                                  " "
                              )
                            ]
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.completed",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.completed
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatDateTime(item.completed)) +
                                  " "
                              )
                            ]
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.progress",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-chip",
                          {
                            staticClass: "status-chip",
                            staticStyle: { padding: "0" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { height: "100%", width: "220px" }
                              },
                              [
                                _vm.loading
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center"
                                          }
                                        },
                                        [
                                          _c("v-progress-circular", {
                                            attrs: {
                                              indeterminate: "",
                                              color: "green",
                                              size: "30",
                                              width: "5"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  : [
                                      _c("v-progress-linear", {
                                        staticClass: "status-progress-bar",
                                        staticStyle: {
                                          "background-color": "lightgreen",
                                          "border-radius": "15px"
                                        },
                                        attrs: {
                                          value: _vm.progressValues[item.id],
                                          height: "100%",
                                          color: "green"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "status-text centered",
                                          staticStyle: {
                                            color: "white",
                                            "font-size": "small"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.progressValues[item.id] +
                                                  "% COMPLETE"
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.reports",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      item.module === "IPE"
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.learnerReportClicked(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-file-document ")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("sessionList.view-report")))
                            ])
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _vm.hasCompletionCertificate(item)
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.completionCertificateClicked(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-medal ")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("sessionList.certificate")) + " "
                              )
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }